import Vue from 'vue'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'

import IndexView from '@/components/views/IndexView'
import AboutView from '@/components/views/AboutView'
import ServiceView from '@/components/views/ServiceView'
import MassageView from '@/components/views/MassageView'
import VoucherView from '@/components/views/VoucherView'
import ContactView from '@/components/views/ContactView'

import NotFoundView from '@/components/views/NotFoundView'

Vue.use(VueHead)
Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: IndexView },
    { path: '/about', component: AboutView },
    { path: '/service', component: ServiceView },
    { path: '/massage', component: MassageView },
    { path: '/voucher', component: VoucherView },
    { path: '/contact', component: ContactView },
    { path: '*', component: NotFoundView }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js